import { createBigDecimal } from '@0xtorch/big-decimal'
import type { Action } from '@0xtorch/core'
import {
  fromIsRelated,
  isFeePayer,
  matchInstructionPattern,
} from '../../conditions'
import { nativeTokenDecimals } from '../../constants'
import { createAction } from '../../generators'
import type { SolanaConverter } from '../../type'

/**
 * Vote プログラムの updateCommission 命令
 * - 投票アカウントの手数料率を更新する操作
 * - トランザクション手数料（SOL）のみが発生
 *
 * **生成する Action**
 * - なし（手数料のみの操作なので action を生成しない）
 *
 * **条件 (一致すべき pattern)**
 * - from
 *   - relatedAddress 内の address である
 * - instructions
 *   - programId が Vote111111111111111111111111111111111111111 である
 *   - instruction type が updateCommission である
 *
 * **判定理由**
 * - programId から Vote プログラムであることを確認
 * - updateCommission は投票アカウントの手数料率を更新するだけの管理操作
 * - SPL トークンや NFT の転送は発生しない
 * - トランザクション手数料のみが発生するため、action として記録する必要がない
 */
const convertToActions: SolanaConverter = (args) => {
  const { transaction, source } = args

  // 送信者が関連アドレスかチェック
  if (!fromIsRelated(args)) return undefined

  // Vote プログラムの updateCommission 命令を確認
  if (
    !matchInstructionPattern(args, {
      pattern: {
        programId: 'Vote111111111111111111111111111111111111111',
      },
    })
  ) {
    return undefined
  }
  const actions: Action[] = []

  // トランザクション手数料をout transferとして追加
  if (isFeePayer(args) && transaction.meta?.fee) {
    const feeAction = createAction({
      order: actions.length,
      type: 'transaction-fee',
      transfers: [
        {
          direction: 'out',
          asset: {
            symbol: 'SOL',
            type: 'CryptoCurrency',
            id: 'solana',
            name: 'Solana',
            updatedAt: 0,
          },
          amount: createBigDecimal(
            BigInt(transaction.meta.fee),
            nativeTokenDecimals,
          ),
        },
      ],
      transaction,
      source,
    })

    actions.push(feeAction)
  }

  return actions
}

export default convertToActions
